import { useEffect, useState } from "react";
import { getbarbers } from "../../api/barberApi";
import {
  getUnavailabilityByBarber,
  createUnavailability,
  deleteUnavailability,
  updateUnavailability,
} from "../../api/barberUnAvailabiltyApi";
import { useAuth } from "../../context/AuthContext";
import EditIcon from "../../assets/icons/edit-icon.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";
const useBarberUnavailability = () => {
  const today = new Date().toISOString().split("T")[0];

  const [barberList, setBarberList] = useState(null);
  const [selectedBarber, setSelectedBarber] = useState(null);
  const [unavailabilities, setUnavailabilities] = useState([]);
  const [unavailability, setUnavailability] = useState(null);
  const [editId, setEditId] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(today);
  const [selectedToDate, setSelectedToDate] = useState(today);

  const [message, setMessage] = useState({ text: "", type: "" });
  const [showMessage, setShowMessage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const columns = [
    {
      header: "Date",
      accessor: "date",
      render: (row) => new Date(row.date).toLocaleDateString(),
    },
    {
      header: "Start Time",
      accessor: "startTime",
      render: (row) => row.startTime ?? "Full Day",
    },
    {
      header: "End Time",
      accessor: "endTime",
      render: (row) => row.endTime ?? "Full Day",
    },
    { header: "Reason", accessor: "reason" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit " onClick={() => onEdit(row.id)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  useEffect(() => {
    fetchBarbers();
    loadUnavailabilities();
  }, []);
  const { user } = useAuth();
  const fetchBarbers = async () => {
    const response = await getbarbers(user.barberShop);
    setBarberList(response);
    setSelectedBarber(response[0]);
  };

  const loadUnavailabilities = async () => {
    if (selectedBarber) {
      const response = await getUnavailabilityByBarber(
        user.barberShop,
        selectedBarber.id,
        selectedFromDate,
        selectedToDate,
      );
      setUnavailabilities(response);
    }
  };
  useEffect(() => {
    if (selectedBarber) {
      loadUnavailabilities();
    }
  }, [selectedBarber, selectedFromDate, selectedToDate]);

  const onAddNewUnavailability = () => {
    setUnavailability(null);
    setEditId(null);
    setShowModal(true);
    setModalMode("add");
  };

  const editUnavailability = (id) => {
    const item = unavailabilities.find((u) => u.id === id);
    setUnavailability(item);
    setEditId(id);
    setShowModal(true);
    setModalMode("edit");
  };

  const onSave = async (data) => {
    if (editId) {
      const unavailability = {
        id: editId,
        shopId: user.barberShop,
        barberId: selectedBarber.id,
        date: data.selectedToDate, // e.g. "Monday" or number (0-6)
        startTime: data.startTime, // "09:00:00"
        endTime: data.endTime, // "17:00:00"
        reason: data.reason,
      };
      const response = await updateUnavailability(
        user.barberShop,
        unavailability,
      );
      if (response && editId == response.data.unavailabilityId) {
        setShowModal(false);
        setModalMode(null);
        setEditId(null);
        setMessage({ text: response.data.message, type: "success" });
        setShowMessage(true);
        setUnavailability(null);
        loadUnavailabilities();
      } else {
        setMessage({
          text: "Failed to update the unavailability",
          type: "danger",
        });
        setShowMessage(true);
      }
    } else {
      const unavailability = {
        ShopId: user.barberShop,
        BarberId: selectedBarber.id,
        FromDate: data.selectedFromDate, // e.g. "Monday" or number (0-6)
        ToDate: data.selectedToDate, // e.g. "Monday" or number (0-6)
        StartTime: data.startTime, // "09:00:00"
        EndTime: data.endTime, // "17:00:00"
        Reason: data.reason,
      };
      await createUnavailability(user.barberShop, unavailability);

      setShowModal(false);
      setModalMode(null);
      loadUnavailabilities();
      setMessage({ text: "Saved successfully", type: "success" });
      setShowMessage(true);
    }
  };

  const handleDeleteClick = (item) => {
    setDeleteItem(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (deleteItem) {
      const response = await deleteUnavailability(
        user.barberShop,
        selectedBarber.id,
        deleteItem.id,
      );
      if (response.success == true) {
        setMessage({ text: response.message, type: "success" });
        setShowMessage(true);
        setDeleteItem(null);
        setShowDeleteModal(false);
        loadUnavailabilities();
      } else {
        setMessage({ text: "Delete is failed", type: "failed" });
        setShowMessage(true);
        setShowDeleteModal(false);
        setDeleteItem(null);
      }
    }
  };

  const onCloseModalClick = () => {
    setModalMode(null);
    setShowModal(false);
  };
  const onCloseDeleteModal = () => setShowDeleteModal(false);

  return {
    barberList,
    selectedBarber,
    unavailabilities,
    selectedToDate,
    columns,
    setSelectedToDate,
    selectedFromDate,
    setSelectedFromDate,
    message,
    showMessage,
    setShowMessage,
    setSelectedBarber,
    unavailability,
    editId,
    editUnavailability,
    onCloseModalClick,
    onAddNewUnavailability,
    onSave,
    showModal,
    setShowModal,
    showDeleteModal,
    onCloseDeleteModal,
    handleDeleteClick,
    handleConfirmDelete,
    modalMode,
  };
};
export default useBarberUnavailability;
